require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./offre-pour-les-rfugis-2-6-7.json") })
        }
      }, "path---offre-pour-les-rfugis-2-6-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---offre-pour-les-rfugis-2-6-7!./.cache/json/offre-pour-les-rfugis-2-6-7.json
// module id = 509
// module chunks = 231608221292675